import React from 'react';
import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS,PAYMENT_PROVIDERS, CURRENCIES_SIGNS} from '@chekin/core';
import {useChekinSDK} from '../context/ChekinSDK';
import {API} from '@chekin/api';

const CACHE_TIME = 60;
const STALE_TIME = 30;
const DEFAULT_PROVIDER = PAYMENT_PROVIDERS.stripe;

function usePaymentSettings() {
  const {isTokenValid} = useChekinSDK();

  const {data: paymentSettings, isLoading} = useQuery({
    queryKey: [QUERY_CACHE_KEYS],
    queryFn: () => API.payments.getPaymentsSettings(),
    enabled: isTokenValid,
    refetchOnWindowFocus: false,
    gcTime: 1000 * 60 * CACHE_TIME,
    staleTime: 1000 * 60 * STALE_TIME,
  });

  const paymentProvider = paymentSettings?.provider || DEFAULT_PROVIDER;

  const isStripePaymentProvider = paymentProvider === PAYMENT_PROVIDERS.stripe;
  const isPaycometPaymentProvider = paymentProvider === PAYMENT_PROVIDERS.paycomet;

  const hasPaymentSettings = Boolean(paymentSettings?.id);

  const getArePaymentProviderValid = React.useCallback(() => {
    if (isStripePaymentProvider) {
      return paymentSettings?.status === 'VALID';
    }

    return true;
  }, [isStripePaymentProvider, paymentSettings?.status]);

  const arePaymentSettingsValid = getArePaymentProviderValid();

  const currency = paymentSettings?.currency;
  const currencySymbol = currency ? CURRENCIES_SIGNS[currency] : '';

  return {
    isPaycometPaymentProvider,
    currencySymbol,
    currency,
    arePaymentSettingsValid,
    isStripePaymentProvider,
    hasPaymentSettings,
    paymentSettings,
    paymentProvider,
    isLoading,
  };
}

export {usePaymentSettings};
